import { Injectable } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { DeviceDTO } from '../models/DeviceDTO.model';
import { tap } from 'rxjs';
import { PlanDeviceDTO } from '../models/PlanDeviceDTO.model';
import { SimpleRequestDTO } from '../shared/models/SimpleRequest';
import { SimpleRequestLongList } from '../shared/models/SimpleRequestLongList';

@Injectable({
  providedIn: 'root'
})
export class AddDeviceService {

  constructor(private httpService: HttpService) { }

  getDeviceByICCID(data: DeviceDTO) {
    return this.httpService.getDeviceByICCID(data).pipe(
      tap((data) => {
      })
    );
  }

  updateDevice(data: DeviceDTO) { 
    return this.httpService.updateDevice(data).pipe(
      tap((data) => {
      })
    );
  }

  createPlanDevice(data: PlanDeviceDTO) { 
    return this.httpService.createPlanDevice(data).pipe(
      tap((data) => {
      })
    );
  }

  getDevicesPlanByIdPlan(data: SimpleRequestDTO) { 
    return this.httpService.getDevicesPlanByIdPlan(data).pipe(
      tap((data) => {
      })
    );
  }

  updatePlanDeviceStatus(data: PlanDeviceDTO) { 
    return this.httpService.updatePlanDeviceStatus(data).pipe(
      tap((data) => {
      })
    );
  }

  getAllUsagesByIdPlan(data: SimpleRequestDTO) { 
    return this.httpService.getAllUsagesByIdPlan(data).pipe(
      tap((data) => {
      })
    );
  }

  updatePlanDevice(data: PlanDeviceDTO) { 
    return this.httpService.updatePlanDevice(data).pipe(
      tap((data) => {
      })
    );
  }

  exportToExcelListPlanDevices(data: SimpleRequestDTO) { 
    return this.httpService.exportToExcelListPlanDevices(data).pipe(
      tap((data) => {
      })
    );
  }

  exportToExcelListPlanDevicesAnnual(data: SimpleRequestDTO) { 
    return this.httpService.exportToExcelListPlanDevicesAnnual(data).pipe(
      tap((data) => {
      })
    );
  }

  exportToExcelListPlanDevicesConsolidated(data: SimpleRequestLongList) { 
    return this.httpService.exportToExcelListPlanDevicesConsolidated(data).pipe(
      tap((data) => {
      })
    );
  }
  
  addDevicesToPlan(data: PlanDeviceDTO[]) {
      return this.httpService.addDevicesToPlan(data).pipe(
        tap((data) => {
        })
      );
    }

}